<template>
  <div>
    <div class="sale-monter-header">
      <div class="brand">
        <nav class="navbar navbar-default">
          <button type="button" class="hide-menu navbar-toggle">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand sale-monter-logo" href="/">
            <img class="img-responsive" src="/static/dists/img/logo.png">
          </a>
          <a class="navbar-brand sale-monter-logo-mobi" href="/">
            <img class="img-responsive" src="/static/dists/img/logomobi.png" alt="">
          </a>
        </nav>
        <div class="member-plan text-size-16" :class="memberPlanClass">
          {{memberPlan}}
        </div>
      </div>
      <div class="categories">
        <div class="box-notifications">
          <div class="notifications">
            <i class="fa fa-bell"></i> <span class="title-notifications"> お知らせ</span>
            <span v-if="countNoticeUnread" class="count-notice-unread">{{ countNoticeUnread }}</span>
          </div>
          <div v-show="showHeaderListNotification" class="header-list-notifications">
            <div class="box-btn-close">
              <a class="btn-close" href="javascript:void(0)">閉じる <i class="fa fa-times"></i></a>
            </div>
            <div v-for="(notice, noticeIndex) in notices" :key="`notice-key-${noticeIndex}`" class="notification">
              <div class="notification-release-date">{{ notice.date }}</div>
              <a
                :class="{'notification-content': true, 'unread': !notice.is_notice_read }"
                href="javascript:void(0)"
                v-html="notice.title"
                @click="handleViewNotice(notice)">
              </a>
            </div>
            <div class="box-btn-view-all text-center" @click="handleViewAllNotice()">
              <a class="btn-view-all" href="javascript:void(0)">すべてのお知らせを表示する</a>
            </div>
          </div>
        </div>
        <div class="mr-r-5 hidden-xs salemon-event">
          <a href="https://salemon.my.canva.site/event" target="_blank"></a>
        </div>
        <div class="seller-info text-white">
          <div>会員ID : <span>{{userInfo.sellerId}}</span></div>
          <div>
            <span :class="{ 'm-r-sm': userInfo.companyName && userInfo.companyName.length > 0 }">
            {{userInfo.companyName || ''}}
            </span>
            <span>
            {{sellerName}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- End refactor header -->
    <!--Navigation-->
    <div class="sidebar-menu">
      <ul id="menu">
        <li class="nav00_bg_color" :class="{ active: $route.name === 'Home' }">
          <router-link :to="{ name: 'Home'}" class="border-top item-menu">
            <i class="fa fa-home" aria-hidden="true"></i>
            <span class="nav-label text-white">ホーム</span>
          </router-link>
          <div class="tooltip-menu-title" style="right: -55px;">ホーム</div>
        </li>
        <li class="nav01_bg_color" :class="{'active': isWarehouseMenuActive}">
          <router-link :to="{name: 'Warehouses'}" class="item-menu">
            <img class="img-reponsive inventory-img" src="/static/dists/img/warehouse.svg" alt=""/>
            <span class="nav-label">倉庫管理</span>
          </router-link>
          <div class="tooltip-menu-title">倉庫管理</div>
        </li>
        <li class="nav01_bg_color menu-product-manager-item" :class="{'active': $route.name === 'ProductsNew'}">
          <router-link :to="{name: 'ProductsNew', params: {tab: 'list'}}" class="item-menu">
            <i class="fa fa-gift" aria-hidden="true"></i>
            <span class="nav-label">商品管理</span>
          </router-link>
          <div class="toggle-side-menu" @click="handleToggleSideMenu()">
            <i class="icon-toggle-side-menu fa fa-caret-left"></i>
          </div>
          <div class="tooltip-toggle-side-menu"></div>
          <div class="tooltip-menu-title">商品管理</div>
        </li>
        <li class="nav01_bg_color" :class="{active: $route.name === 'Revenue' || $route.name === 'ReqMoney'}">
          <router-link :to="{name: 'Revenue'}" class="item-menu">
            <i class="fa fa-jpy" aria-hidden="true"></i>
            <span class="nav-label">売上管理</span>
          </router-link>
          <div class="tooltip-menu-title">売上管理</div>
        </li>
        <li class="nav01_bg_color" :class="{active: $route.name === 'Revdetail'}">
          <router-link :to="{name: 'Revdetail'}" class="item-menu">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span class="nav-label">売上明細</span>
          </router-link>
          <div class="tooltip-menu-title">売上明細</div>
        </li>
        <li class="nav01_bg_color" :class="{active: $route.name === 'Promotion'}">
          <router-link :to="{name: 'Promotion', params: {tab: 'top'}}" class="item-menu">
            <i class="fa fa-bullhorn" aria-hidden="true"></i>
            <span class="nav-label">広告管理</span>
          </router-link>
          <div class="tooltip-menu-title">広告管理</div>
        </li>
        <li class="nav01_bg_color" :class="{active: $route.name === 'Affiliate'}">
          <router-link :to="{name: 'Affiliate', params: {tab: 'top'}}" class="item-menu">
            <i class="fa fa-comment-o" aria-hidden="true"></i>
            <span class="nav-label">紹介制度</span>
          </router-link>
          <div class="tooltip-menu-title">紹介制度</div>
        </li>
        <li class="nav01_bg_color" :class="{ active: $route.name === 'Setting' }">
          <router-link :to="{ name: 'Setting', params: {tab: 'plan-info'}}" class="item-menu">
            <i class="fa fa-cog" aria-hidden="true"></i>
            <span class="nav-label">設定</span>
          </router-link>
          <div class="tooltip-menu-title" style="right: -43px;">設定</div>
        </li>
        <li class="nav01_bg_color" :class="{ active: $route.name === 'Question Answer' }">
          <router-link :to="{ name: 'Question Answer'}" class="item-menu">
            <i class="fa fa-question-circle-o" aria-hidden="true"></i>
            <span class="nav-label">Q&A</span>
          </router-link>
          <div class="tooltip-menu-title" style="right: -44px;">Q&A</div>
        </li>
        <li class="nav01_bg_color" :class="{ active: $route.name === 'External Services' }">
          <router-link :to="{ name: 'External Services'}" class="item-menu">
            <i class="fa fa-handshake-o" aria-hidden="true"></i>
            <span class="nav-label">提携サービス</span>
          </router-link>
          <div class="tooltip-menu-title" style="right: -100px;">提携サービス</div>
        </li>
        <li class="nav01_bg_color" :class="{ active: $route.name === 'Request' }">
          <router-link :to="{ name: 'Request'}" class="item-menu">
            <i class="fa fa-comments" aria-hidden="true"></i>
            <span class="nav-label">だれでも掲示板</span>
          </router-link>
          <div class="tooltip-menu-title" style="right: -87px;">リクエスト</div>
        </li>
        <li class="nav01_bg_color" :class="{'active': $route.name === 'Notices'}">
          <router-link :to="{name: 'Notices'}" class="item-menu">
            <i class="fa fa-bell" aria-hidden="true"></i>
            <span class="nav-label">お知らせ</span>
          </router-link>
          <div class="tooltip-menu-title">お知らせ</div>
        </li>
        <li class="nav01_bg_color">
          <a @click="doLogout" class="item-menu">
            <i class="fa fa-sign-out" aria-hidden="true"></i>
            <span class="nav-label">ログアウト</span>
          </a>
          <div class="tooltip-menu-title" style="right: -85px;">ログアウト</div>
        </li>
        <br>
        <li class="nav01_bg_color version-info">
          <p class="text-white text-center">version: {{ appVersion }}</p>
        </li>
      </ul>
      <footer class="footer text-center m-b-md">
        <a class="text--underline" :href="downloadUrl" download target="_blank">
          <span>利用規約</span>
        </a>
        <br>
        <a class="text--underline" :href="downloadUrlV2" download target="_blank">
          <span>プライバシーポリシー</span>
        </a>
      </footer>
    </div>
    <!-- Page Content -->
    <div id="wrapper">
      <reload-notification v-if="isChanged" data-backdrop="static" data-keyboard="false" @reload="reload"></reload-notification>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import ReloadNotification from '@/components/ReloadNotification'
import SettingService from '@/services/settingservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ReloadNotification
  },
  data () {
    return {
      downloadUrl: `${process.env.NODE_DOMAIN}/static/dists/pdf/contract.pdf`,
      downloadUrlV2: `https://www.hcube3.com/PDF/personal.pdf`,
      isChanged: false,
      version: '',
      showHeaderListNotification: false
    }
  },
  created () {
    this.fetchServer()
    this.$store.dispatch('fetchNotices')
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      notices: 'getNotices',
      countNoticeUnread: 'countNoticeUnread'
    }),
    sellerName () {
      const {sellerName} = this.userInfo
      return sellerName ? `${sellerName}様` : ''
    },
    appVersion () {
      return this.$store.getters.getUser.version
    },
    isWarehouseMenuActive () {
      let activeRouteNames = [
        'Warehouses',
        'Delivery Requests',
        'Warehouse Amazon'
      ]
      let routeName = this.$route.name
      return activeRouteNames.includes(routeName)
    },
    storageSkipShowRegisterInfoName () {
      return `${this.userInfo.sellerId}-SkipShowRegisterInfo`
    },
    storageSideMenuCloseName () {
      return `${this.userInfo.sellerId}-SideMenuClose`
    },
    memberPlan () {
      if (this.userInfo.memberPlan === '1') {
        return 'プレミアム'
      }
      return 'ベーシック'
    },
    memberPlanClass () {
      if (this.userInfo.memberPlan === '1') {
        return 'plan-premium-text plan-premium-bg'
      }
      return 'plan-basic-text plan-basic-bg'
    }
  },
  watch: {
    $route (to, from) {
      if (to.name !== 'Notices' || (to.query && !to.query.scroll_to)) {
        this.fetchServer()
      }
    }
  },
  methods: {
    doLogout () {
      $('body').removeClass('show-sidebar')
      let token = localStorage.getItem('tokenSalmon')
      let customHeaders = {}
      if (token) {
        customHeaders = { Authorization: `Bearer ${token}` }
      }
      let logParams = {
        name: eventCode.click_logout_button,
        properties: {}
      }
      EventService.postTrackLog(logParams, customHeaders)

      localStorage.removeItem(this.storageSkipShowRegisterInfoName)
      store.dispatch('doLogout')
      this.$router.push('/login')
    },
    async fetchServer () {
      try {
        let params = {}
        let routeName = this.$route.name
        if (routeName === 'Home') {
          params = { screen_name: 'Home' }
        }
        const response = await SettingService.getSellerInformation(params)
        const nextVersion = response.seller.version
        const currentVersion = this.$store.getters.getUser.version
        if (currentVersion !== nextVersion) {
          this.version = nextVersion
          this.isChanged = true
        }
        this.$store.commit('setUser', response.seller)
      } catch (err) {
        this.err = err
      }
    },
    reload () {
      $('#reloadNotification').modal('hide')
      store.commit('setVersion', this.version)
      location.reload(true)
    },
    handleViewNotice (notice) {
      this.showHeaderListNotification = false
      this.$router.push(`/Notices?scroll_to=${notice.id}`)
      this.handleScrollToNotice()
    },
    handleViewAllNotice () {
      this.showHeaderListNotification = false
      this.$router.push('/Notices?scroll_to=top')
      this.handleScrollToNotice()
    },
    handleToggleHeaderNotification () {
      let toggleHeaderNotiClasses = ['notifications', 'fa fa-bell', 'title-notifications', 'count-notice-unread']
      let notToggleHeaderNotiClasses = ['box-btn-close', 'header-list-notifications', 'notification-release-date', 'notification-content', 'notification-content unread', 'notification']
      window.addEventListener('click', (e) => {
        let eventClass = $(e.target).attr('class')
        if (eventClass !== null && eventClass !== undefined) {
          if (toggleHeaderNotiClasses.includes(eventClass)) {
            this.showHeaderListNotification = !this.showHeaderListNotification
          } else if (eventClass === 'btn-close') {
            this.showHeaderListNotification = false
          } else if (!notToggleHeaderNotiClasses.includes(eventClass)) {
            this.showHeaderListNotification = false
          }
        } else {
          this.showHeaderListNotification = false
        }
      })
    },
    handleScrollToNotice () {
      let route = this.$route
      let routeName = route.name
      if (routeName === 'Notices') {
        let noticeId = route.query.scroll_to || null
        if (!noticeId || noticeId === 'top') {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        } else if (noticeId) {
          setTimeout(() => {
            let elementId = `panel-notice-${noticeId}`
            const element = document.getElementById(elementId)
            if (element) {
              let collapseNoticeSelector = $(`#collapse-notice-${noticeId}`)
              collapseNoticeSelector.attr('aria-expanded', true)
              collapseNoticeSelector.addClass('in')
              $(`#panel-notice-${noticeId} .accordion-title`).attr('aria-expanded', true)

              window.scroll({
                top: (element.getBoundingClientRect().top + window.scrollY) - 70,
                behavior: 'smooth'
              })
            }
          }, 600)
        }
      }
    },
    handleToggleSideMenu () {
      let sideMenuSelector = $('.sidebar-menu')
      let menuSelector = $('#menu')
      let wrapperSelector = $('#wrapper')
      let itemMenuSelector = $('.item-menu')
      let versionInfoSelector = $('.version-info')
      let footerSelector = $('footer')
      let iconToggleSideMenuSelector = $('.icon-toggle-side-menu')
      let closeTitle = '閉じる'
      let openTitle = '開く'
      let tooltipToggleSideMenuSelector = $('.tooltip-toggle-side-menu')

      footerSelector.toggleClass('item-hidden')
      versionInfoSelector.toggleClass('item-hidden')
      setTimeout(() => {
        sideMenuSelector.toggleClass('sidebar-menu-close')
        menuSelector.toggleClass('menu-close')
        wrapperSelector.toggleClass('wrapper-side-menu-close')
        itemMenuSelector.children('span').toggleClass('menu-name-hidden')
        iconToggleSideMenuSelector.toggleClass('fa-caret-right')

        if (menuSelector.hasClass('menu-close')) {
          localStorage.setItem(this.storageSideMenuCloseName, true)
          tooltipToggleSideMenuSelector.text(openTitle)
        } else {
          localStorage.setItem(this.storageSideMenuCloseName, false)
          tooltipToggleSideMenuSelector.text(closeTitle)
        }
      }, 300)
    }
  },
  mounted () {
    this.handleToggleHeaderNotification()
    let itemMenuSelector = $('.item-menu')
    let menuSelector = $('#menu')
    let toggleSideMenuSelector = $('.toggle-side-menu')
    itemMenuSelector.hover(function () {
      if (menuSelector.hasClass('menu-close')) {
        $(this).siblings('.tooltip-menu-title').toggleClass('tooltip-menu-title-active')
      }
    })

    toggleSideMenuSelector.hover(function () {
      let closeTitle = '閉じる'
      let openTitle = '開く'
      let tooltipToggleSideMenuSelector = $('.tooltip-toggle-side-menu')
      if (menuSelector.hasClass('menu-close')) {
        tooltipToggleSideMenuSelector.text(openTitle)
      } else {
        tooltipToggleSideMenuSelector.text(closeTitle)
      }
      $(this).siblings('.tooltip-toggle-side-menu').toggleClass('tooltip-toggle-side-menu-active')
    })
  }
}
</script>
<style scoped>
  .salemon-event a {
    width: 200px;
    height: 40px;
    display: block;
    background: url("/static/dists/img/linkToSalmonPortal.png") no-repeat;
    background-size: 200px 40px;
  }
  .salemon-event a:hover {
    background-image: url("/static/dists/img/linkToSalmonPortal_hover.png");
  }
  @media (max-width: 425px) {
    .text-size-16 {
      font-size: 12px;
    }
    .member-plan {
      width: 60px;
    }
    .sale-monter-header .seller-info  {
      padding: 0;
      padding-right: 5px;
    }
    .sale-monter-header .brand {
      gap: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainFrame.vue